module.exports = __webpack_public_path__ + "static/img/picture1.c2a9d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swipe/picture1.jpg
// module id = Kufg
// module chunks = 0